import React, { useState, useEffect } from "react";
import { LevelContainer } from "./LevelSeven.styled";
import { useHistory } from "react-router-dom";
// import CherryPopup from "../../components/CherryPopup";
import starSVG from "../../assets/images/LevelSeven/star.svg";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";
import Navbar from "../../components/common/Navbar";

export default function LevelSeven(props) {
  const [skullTiles, setSkullTiles] = useState([
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [character, setCharacter] = useState("");
  const [isComplete, setComplete] = useState(false);
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);
  let history = useHistory();
  const nextLevel = () => {
    // props.toggleHint(false);
    // props.transition.volume = 0.6;
    // props.transition.play();
    // history.push("/8");
  };
  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        setMove(true);
      }
    }, 500);
  }, [won]);
  // useEffect(() => {
  //   setTimeout(() => {
  //     props.toggleHint(true);
  //   }, 10000);
  //   props.changeLevelName("Blindspot");
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    switch (props.character) {
      case "1":
        setCharacter(
          !props.mode
            ? require("../../assets/images/LevelTwo/nyan-cat.svg")
            : require("../../assets/images/LevelTwo/nyan-cat-dark.svg")
        );
        break;
      case "2":
        setCharacter(
          !props.mode
            ? require("../../assets/images/LevelTwo/skull-player-light.svg")
            : require("../../assets/images/LevelTwo/skull-player-dark.svg")
        );
        break;
      case "3":
        setCharacter(
          !props.mode
            ? require("../../assets/images/LevelTwo/ghost-person.svg")
            : require("../../assets/images/LevelTwo/ghost-person-dark.svg")
        );
        break;
      default:
        break;
    }
  }, [props.character, props.mode]);

  useEffect(() => {
    if (checkWin()) {
      // props.clear.volume = 0.6;
      // props.clear.play();
      setComplete(true);
      setWon(true);
    }
    // eslint-disable-next-line
  }, [skullTiles]);

  const checkWin = () => {
    let flag = true;
    skullTiles.forEach((skull) => {
      if (skull === false) {
        flag = false;
      }
    });
    return flag;
  };

  const handleClick = (index) => {
    // props.click.volume = 0.3;
    // props.click.currentPosition = 0;
    // props.click.play();
    if (index === 5) {
      document.querySelector(`.skull5`).style.pointerEvents = "none";
      let randomIndex = Math.floor(Math.random() * 12);
      document.querySelector(`.skull${randomIndex}`).style.visibility =
        "visible";
      document.querySelector(`.skull${randomIndex}`).style.animation =
        "blink .1s ease";
      setTimeout(() => {
        document.querySelector(`.skull${randomIndex}`).style.animation = "none";

        if (skullTiles[randomIndex] === true) {
          document.querySelector(`.skull${index}`).style.visibility = "visible";
          document.querySelector(`.skull${index}`).style.opacity = "1";
        }
      }, 100);
    } else {
      setTimeout(() => {
        document.querySelector(`.skull${index}`).style.visibility = "visible";
        document.querySelector(`.skull${index}`).style.opacity = "1";
        let skulls = [...skullTiles];
        skulls[index] = !skulls[index];
        setSkullTiles(skulls);
      }, 200);
    }
    setTimeout(() => {
      document.querySelector(`.skull5`).style.visibility = "visible";
      document.querySelector(`.skull5`).style.pointerEvents = "all";
    }, 200);
  };
  return [
    move && <LevelComplete levelNum={1} />,
    <Navbar won={won} levelNum={1} />,
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
      }}
      className="level-7-containter"
    >
      <LevelContainer mode={true}>
        {/* <div className="top-left-dot"></div>
      <div className="bottom-left-dot"></div>
      <div className="top-right-dot"></div>
      <div className="bottom-right-dot"></div> */}
        {skullTiles.map((skull, i) => (
          <div
            key={i}
            onClick={() => handleClick(i)}
            className={`skull-div skull${i}`}
            style={{
              opacity: skull ? "1" : "0",
              visibility: skull ? "visible" : "hidden",
            }}
          >
            <img key={i} src={starSVG} alt="skull" draggable={false} />
          </div>
        ))}
      </LevelContainer>
    </div>,
    // ,
    // <CherryPopup
    //   isComplete={isComplete}
    //   nextLevel={nextLevel}
    //   mode={props.mode}
    //   levelName="Stereoshift"
    // />,
  ];
}
